import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import axios from 'axios';
// import { getFirestore, collection } from 'firebase/firestore'

import { vuexfireMutations, firestoreAction } from 'vuexfire'
import plans from '../plans'

import actionsUsers from './actions/users'
import actionsDatasets from './actions/datasets'
import actionsModels from './actions/models'
import actionsProjects from './actions/projects'
import actionsDocuments from './actions/documents'
import actionsBackend from './actions/backend_api'

Vue.use(Vuex)
const pipelineApiKey = "7hsWCpnq7Y5WKATNvCAQM6BVAVnsAWpoxudZzgCj"
const pipelineApiConfig = {
    "headers": {
        "x-api-key": pipelineApiKey,
        "Content-Type": "application/json"
    }
}

export default new Vuex.Store({
  state: {
    modal: "",
    currentUser: "",
    currentOrg: "",
    boards: "",
    models: "",
    publicModels: "",
    dataset: "",
    project: "",
    projects: "",
    newProject: "",
    publicDatasets: "",
    datasets: "",
    pages: "",
    items: [],
    datasetDocuments: "",
    modelAdded: "",
    currentModel: "",
    currentModelDatasets: "",
    currentPage: "",
    currentBoardItems: [],
    datasetWordcloud: "",
    modelMonitoring: "",
    datasetDocumentsUnlabeled: "",
    datasetDocumentsError: "",
    projectUploads: "",
    currentDatasets: "",
    projectDocuments: "",
    projectLogging: "",
    projectModels: "",
    projectModelLogs: "",
    retrieveAllProjects: "",
    projectsPublic: "",
    users: "",
    getUser: "",
    plans: plans,
    listPlans: "",
    rows: [],
    logs: [],

    logs_resume: [],
    documents: "",
    metrics: [],
    isLoading: false,
    pre_build_models: [],
    usage: [],
    prediction_results: [],
    checkout: {},
    viewModels: false,
  },
  mutations: {
    ...vuexfireMutations,
    setCheckoutParams (state, payload) {
        state.checkout = {
            plan: payload.plan,
            credits: payload.credits,
            method: payload.method,
            license: payload.license,
            licenseCode: payload.licenseCode,
            onboarding: payload.onboarding
        }
    },
    SET_LOGS (state, payload) {
        state.logs = {
            data: payload.logs,
            nextKey: payload.nextKey || {}
        }
    },
    SET_LOGS_RESUME (state, payload) {
        state.logs_resume = payload.logs
    },
    setRows (state, payload) {
        state.rows = payload.rows
    },
    updateRow (state, payload) {
        let rowId = payload.row.id
        
        let index = state.rows.findIndex(i => i.id == rowId)
        
        Vue.set(state.rows, index, {...state.rows[index], ...payload.row});
        
    },
    deleteRow (state, payload) {
        let rowId = payload.rowId
        let index = state.rows.findIndex(i => i.id == rowId)
        state.rows.splice(index, 1)
    },
    setProgressMetrics (state, payload) {
        let project_labels = []
        let metrics_per_label = []
        let rows = payload.rows
        let labels = []
        let labels_unique = []

        if (state.project.labels){
            project_labels = state.project.labels.map(({ label }) => label)
        }
        if (rows === undefined || rows === false){
            rows = []
        }
        if (state.project.type == 'extraction'){
            labels = rows.filter(i => Array.isArray(i.tags) && i.tags.length > 0 && i.tags != false).map(i => { i.tags.map(j => {j.label}) })
        } else if (state.project.type == 'classification'){
            labels = rows.filter(i => Array.isArray(i.labels) && i.labels != false).map(i => {i.labels})
        }
        labels = [...labels, ...project_labels]
        labels_unique = [...new Set(labels)]
        labels_unique = labels_unique.filter(i => i !== null && i !== undefined && i !== '' && i !== 'False')
        
        labels_unique.sort()

        const calc_for_classification = (rows, label) => {
            return {
                'label': label,
                'labeled': rows.filter(i => Array.isArray(i.labels) && i.labels.includes(label)).length,
                'correct': rows.filter(
                    row => ( 
                        Array.isArray(row.prediction) && row.prediction.includes(label)
                    ) && (
                        Array.isArray(row.labels) && row.labels.includes(label)
                    )
                ).length,
                'incorrect': rows.filter(
                    row => ( 
                        Array.isArray(row.prediction) && row.prediction.length > 0 && !row.prediction.includes(label)
                        ) && (
                            Array.isArray(row.labels) && row.labels.includes(label)
                        )
                ).length,
                'missed': rows.filter(
                    row => ( 
                        !Object.hasOwn(row, 'prediction') || (Array.isArray(row.prediction) && row.prediction.length < 1)
                    ) && (
                        !Object.hasOwn(row, 'labels') || (Array.isArray(row.labels) && row.labels.includes(label) || row.labels.length < 1)
                    )
                ).length,
                'unlabeled': rows.filter(
                    row => (
                        !Object.hasOwn(row, 'labels') || (Array.isArray(row.labels) && !row.labels.includes(label) && row.labels.length < 1)
                    )
                ).length
            }
        }

        const is_tagged_to_label = (tags, label) => {
            if (tags === undefined || tags === false || tags.length < 1){
                return false
            }
            // tags = [{label: 'label', start: 0, end: 1}, {label: 'label', start: 0, end: 1]
            // label = 'label'
            return tags.filter(i => i.label == label).length > 0
        }

        const calc_for_extraction = (rows, label) => {
            return {
                'label': label,
                'labeled': rows.filter(i => Array.isArray(i.tags) && is_tagged_to_label(i.tags, label)).length,
                'predicted': rows.filter(i => Array.isArray(i.prediction) && is_tagged_to_label(i.tags, label)).length,
                'correct': rows.filter(
                    row => ( 
                        Array.isArray(row.prediction) && is_tagged_to_label(row.prediction, label)
                    ) && (
                        Array.isArray(row.tags) && is_tagged_to_label(row.tags, label) && row.tags.filter( tag => tag.label == label && row.prediction.filter( p => p.text == tag.text).length > 0).length > 0
                    )
                ).length,
                'incorrect': rows.filter(
                    row => ( 
                        Array.isArray(row.prediction) && row.prediction.length > 0 && !is_tagged_to_label(row.prediction, label)
                        ) && (
                            Array.isArray(row.tags) && is_tagged_to_label(row.tags, label)
                        )
                ).length,
                'missed': rows.filter(
                    row => ( 
                        !Object.hasOwn(row, 'prediction') || (Array.isArray(row.prediction) && row.prediction.length < 1)
                    ) && (
                        !Object.hasOwn(row, 'tags') || (Array.isArray(row.tags) && is_tagged_to_label(row.tags, label) || row.tags.length < 1)
                    )
                ).length,
                'unlabeled': rows.filter(
                    row => (
                        !Object.hasOwn(row, 'tags') || (Array.isArray(row.tags) && !is_tagged_to_label(row.tags, label) && row.tags.length < 1)
                    )
                ).length
            }
        }

        for (let label of labels_unique){
            
            label = !Array.isArray(label) ? label.trim() : label[0].trim()
            
            if (state.project.type == 'extraction'){
                metrics_per_label.push(calc_for_extraction(rows, label))
            } else if (state.project.type == 'classification'){
                metrics_per_label.push(calc_for_classification(rows, label))
            }
        }

        state.metrics = metrics_per_label
    },
    SET_PRE_BUILD_MODELS (state, payload) {
        state.pre_build_models = payload.models
    },
    setLoading (state, isLoading) {
        state.isLoading = isLoading
    },
    SET_PREDICTION_RESULTS (state, payload) {
        state.prediction_results = payload.results
    },
    setViewModels (state, payload) {
        state.viewModels = payload.show
    },
  },
  getters: {
    showViewModels: (state) => {
        return state.viewModels
    },
    getPredictionsResult: (state) => {
        return state.prediction_results
    },
    isLoading: (state) => {
        return state.isLoading
    },
    getRows: (state) => {
        return state.rows
    },
    rowsByDataset: (state) => (datasetId, annotationMode = false) => {
        return state.rows
    },
    progressMetrics: (state) => (datasetId) => {
        return state.metrics
    },
    logsByModel: (state) => () => {
        return state.logs
    },
    logsResumeByModel: (state) => () => {
        return state.logs_resume
    },
    preBuildModels: (state) => {
        return state.pre_build_models
    }
  },
  actions: {
    ...actionsUsers, 
    ...actionsDatasets, 
    ...actionsModels, 
    ...actionsProjects, 
    ...actionsDocuments,
    ...actionsBackend,
    listPlans: () => { 
      return plans;
    },
    showViewModels: ({commit}, show) => {
        commit('setViewModels', {show: show})
    },
    datasetAnalysis: ({dispatch, commit}, row) => {

        const api = `${process.env.VUE_APP_CLOUD_FUNCTIONS_URL}/upload`
        let data = {
            "datasetId": row.datasetId,
            "uploadId": row.uploadId,
            "taskType": row.taskType
        }
        
        return axios.post(api, data, pipelineApiConfig)
                .then(res => res.data)
                .catch(err => console.log(err));
    },
    getPreBuildModelInference: ({dispatch, commit}, payload) => {
        
        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/prompt/inference/${payload.modelId}`
        
        let data = {
            "text": payload.text
        }
        if (payload.labels) {
            data = {
                "text": payload.text,
                "labels": payload.labels,
                "multilabel": payload.multilabel
            }
        }
       
        return axios.post(api, data, pipelineApiConfig)
        .then(  res => res.data.prediction)
        .catch( err => console.log(err))
    },
    addRecord: ({dispatch, commit}, payload) => {
        
        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/projects/${payload.projectId}/records`
        
        const data = {
            "text": payload.text,
            "labels": payload.labels,
            "tags": payload.tags
        }
        
        return axios.post(api, data, pipelineApiConfig)
        .then(  res => res.data)
        .catch( err => console.log(err))
    },
    updateLogsRecord: ({dispatch, commit}, payload) => {
        
        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/logs/update/${payload.uid}`

        const data = {
            uid: payload.uid,
            apiKey: payload.apiKey,
            fields: payload.fields,
        }
        
        return axios.put(api, payload, pipelineApiConfig)
        .then(  res => res.data)
        .catch( err => console.log(err))
    },
    getLogsByModel: ({commit}, payload) => {
        let api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/logs/get-logs-paginated/${payload.model_id}/records` +
                   `?page_size=${payload.page_size}` +
                   `&predictions=${payload.predictions}` +
                   `&score=${payload.score}` + 
                   `&is_recorded=${payload.is_recorded}` + 
                   `&next_token=${payload.next_token}`;

        return axios.get(api, pipelineApiConfig)
        .then(  r => r.data )
        .catch( err => console.log(err))

    },
    getLogsResumeByModel: ({commit}, modelId) => {
        let api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/logs/resume-by-model/${modelId}`
        
        return axios.get(api, pipelineApiConfig)
        .then( r => r.data)
        .catch( err => console.log(err))
    },
    savePredictionResults: ({commit}, results) => {
        commit('SET_PREDICTION_RESULTS', {results: results})
    },
    getPreBuildModels: ({commit}) => {
        let api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/prompt/pre-build-models`
        
        axios.get(api, pipelineApiConfig).then( (r) => {
            commit('SET_PRE_BUILD_MODELS', {models: r.data.models})
        })
    },
    getProgressMetrics: ({commit}) => {
        commit('setProgressMetrics', {rows: false})
    },
    getRowsByDataset: ({commit}, datasetId) => {
        let api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/rows/get-by-dataset/${datasetId}`
        commit('setLoading', true)
        axios.get(api, pipelineApiConfig).then( (r) => {
            commit('setRows', {rows: r.data, datasetId: datasetId})
            commit('setLoading', false)
            commit('setProgressMetrics', {rows: r.data, datasetId: datasetId})
        })
    },
    createRow: ({dispatch, commit}, row) => {

        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/rows/create`
        const data = {
            "id": null,
            "datasetId": row.datasetId,
            "uploadId": row.uploadId,
            "projectId": row.projectId,
            "filename": row.filename,
            "text": row.text,
            "updatedAt": Date.now(),
            "createdAt": Date.now()
        }
        
        axios.post(api, data, pipelineApiConfig)
        
        
    },
    updateRow: ({dispatch, commit}, row) => {

        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/rows/update`

        const rowToUpdate = {
            datasetId: row.datasetId,
            id: row.id,
            labels: row.labels,
            tags: row.tags,
            suggestion: row.suggestion,
            updatedAt: Date.now()
        }
        
        axios.put(api, rowToUpdate, pipelineApiConfig).then( () => {
            commit('updateRow', {row: rowToUpdate})
            // dispatch('getRowsByDataset', row.datasetId);
            // commit('setProgressMetrics', {rows: false})
            
        })
    },
    deleteRow: ({dispatch, commit}, rowId) => {
        
        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/rows/delete/${rowId}`
        axios.delete(api, pipelineApiConfig).then( () => {
            commit('deleteRow', {rowId: rowId})
        })
    },
    changeAPIUsagePlan: ({dispatch, commit}, user) => {

        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/apigateway/change-usage-plan`
        
        const data = {
            "user_id": user.userId,
            "new_plan_name": user.newPlan,
            "new_credits_quota": parseInt(user.newCreditsQuota)
        }
        
        axios.post(api, data, pipelineApiConfig)
    },
    updateAPIUsageByUser: ({dispatch, commit}, user) => {

        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/apigateway/usage-by-user`
        
        const data = {
            "user_id": user.userId,
            "usage_plan_id": user.usagePlanId,
            "api_key_id": user.apiKeyId
        }
        
        axios.post(api, data, pipelineApiConfig)
    },
    updateAPICreditsConsumed: ({dispatch, commit}, user) => {

        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/apigateway/update-credits-consumed`
        
        const data = {
            "user_id": user.userId,
            "credits_consumed": parseInt(user.creditConsumed),
        }
        
        axios.post(api, data, pipelineApiConfig)
    },
    runAutoLabel: ({dispatch, commit}, payload) => {

        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/labeling`
        
        const data = {
            "projectId": payload.projectId,
            "filter": payload.filter,
        }
        
        axios.post(api, data, pipelineApiConfig)
    },
    runInference({dispatch, commit}, payload) {

        let time1 = performance.now();
        let urls = {
            "other": `${process.env.VUE_APP_PIPELINE_URL}/v1/inference`,
            "classification": `${process.env.VUE_APP_INFERENCE_URL}/v2/classify`,
            "extraction": `${process.env.VUE_APP_INFERENCE_URL}/v2/extract`,
            'answering': `${process.env.VUE_APP_PIPELINE_URL}/v1/answering`,
            'generation': `${process.env.VUE_APP_PIPELINE_URL}/v1/generation`,
        }
        let type = payload.type
        
        if (!urls[type]){
            type = "other"
        }
        
        payload.base_url = urls[type]
        payload.options = {refresh: payload.refresh, version: payload.modelId}
        payload.version = payload.modelId
        
        return axios.post(
            `${process.env.VUE_APP_CLOUD_FUNCTIONS_URL}/inference/${payload.projectId}`, 
            payload
        ).then( res => {
            let time2 = performance.now();
            console.log(`Inference took ${time2 - time1} milliseconds.`)
            return res.data
        }).catch( err => {
            return false
        })
    },
  }
})